<style>
.edi-forgot {
	height: 100%;
	background-color: #eee;
}
</style>

<template>
	<div>
		<navbar title="忘记密码"></navbar>
		<form class="ui-content edi-forgot" @submit.prevent="onCheckSubmit">
			<ul class="ui-listview ui-listview-inset">
				<li class="ui-listview-one-item"><input type="text" name="telephone" placeholder="手机号" class="ui-align-center" v-model="telephone"/></li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" value="确定" class="submit" :class="{ 'ui-disable': submitDisable }"/>
			</fieldset>
			<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
			<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		</form>
	</div>
</template>

<script>
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			telephone: '',
			// patrn: /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/,
			patrn: /^([0-9]{11})$/,
			sec: 1500
		}
	},
	components: {
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	computed: {
		submitDisable () {
			return !this.telephone
		}
	},
	methods: {
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		onCheckSubmit (e) {
			if (this.submitDisable) return
			if (this.telephone === '') {
				this.autoTips('手机号码不能为空')
				return false
			} else if (!(this.patrn.test(this.telephone))) {
				this.autoTips('手机号码格式不正确')
				return false
			}
			this.forgotPost()
		},
		forgotPost () {
			this.$http.get(`/cldEdi/business/authentication/mobile/${this.telephone}`).then(res => {
				var data = res.body
				if (!data.result) {
					this.tips = true
					this.tipsFont = data.message
					return false
				} else {
					this.$router.push({ path: '/password-modify', query: { telephone: this.telephone } })
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// Forgot.vue?4863e6ca